
import Crown from "./images/svg/crown.svg";
import Info from "./images/svg/info.svg";
import Check from "./images/svg/check.svg";
import SearchIcon from "./images/svg/search_icon.svg";
import FilterIcon from "./images/svg/filterIcon.svg";
import DownArrow from "./images/svg/Down.svg";
import UpArrow from "./images/svg/Up.svg";
import Bookmarks from "./images/svg/bookmark.svg";
import Book from "./images/svg/books.svg";
import Clock from "./images/svg/clock.svg";
import Lock from "./images/svg/lock.svg";
import BookMarkSave from "./images/svg/bookmarkSave.svg";
import BackArrow from "./images/svg/backArrow.svg";
import PracticeTestBG from "./images/svg/practiceTestBg.svg";
import PracticeTestArt from "./images/svg/practiceTestArt.svg";
import IcPracticeTest from "./images/svg/ic_practice_test.svg";
import IcRightIcon from "./images/svg/right_icon.svg";
import Circle1 from "./images/svg/thick_circle_overlay.svg";
import Circle2 from "./images/svg/circle_2.svg";
import Circle3 from "./images/svg/circle_3.svg";
import ChangeIcon from "./images/svg/change_exam.svg";
import HomeIcon from "./images/svg/Home_icon.svg";
import dashboardIcon from "./images/svg/dashboard_icon.svg";
// Colors moved to @learnzapp/core/theme (shared with mobile — see
// packages/core/src/theme). The COLORS/COLORS_DARK objects that used to live
// here were dead web-side (the runtime theme came from colorTheme.js, now
// also retired); ThemeProvider imports getColorTheme from the core package.
// This file keeps only the web image/SVG asset maps.

export const IMAGES = {
  background: require("./images/background.png"),
  ic_apple: require("./images/ic_apple.png"),
  ic_google: require("./images/ic_google.png"),
  ic_skip: require("./images/ic_skip.png"),
  slide_1: require("./images/slide_1.png"),
  slide_2: require("./images/slide_2.png"),
  slide_3: require("./images/slide_3.png"),
  slide_4: require("./images/slide_4.png"),
  slide_5: require("./images/slide_5.png"),
  ic_back: require("./images/ic_back.png"),
  info_background: require("./images/info_background.png"),
  logo: require("./images/logo_prepare.png"),
  // White-label partner logos. Served from public/assets/images (switch-app copies the
  // brand's assets/images there). Referenced by public URL — these files only exist for
  // white-label brands, so they must not be bundled via require().
  client_logo_light: "/assets/images/client_logo_light.svg",
  client_logo_dark: "/assets/images/client_logo_dark.svg",
  crown: require("./images/crown.png"),
  price_crown: require("./images/price_crown.png"),
  quick_assessment: require("./images/quick_assessment.png"),
  ic_dark_mode: require("./images/ic_dark_mode.png"),
  ic_light_mode: require("./images/ic_light_mode.png"),
  ic_notification: require("./images/ic_notification.png"),
  ic_account: require("./images/ic_account.png"),
  ic_profile: require("./images/ic_profile.png"),
  ic_avatar: require("./images/ic_avatar.png"),
  ic_subscription: require("./images/ic_subscription.png"),
  ic_share_app: require("./images/ic_share_app.png"),
  ic_other_app: require("./images/ic_other_app.png"),
  ic_help: require("./images/ic_help.png"),
  ic_signout: require("./images/ic_signout.png"),
  ic_camera: require("./images/ic_camera.png"),
  ic_tab_home: require("./images/ic_tab_home.png"),
  ic_tab_dashboard: require("./images/ic_tab_dashboard.png"),
  ic_tab_hisotry: require("./images/ic_tab_hisotry.png"),
  ic_tab_study_plan: require("./images/ic_tab_study_plan.png"),
  ic_tab_bookmark: require("./images/ic_tab_bookmark.png"),
  ic_notification_home: require("./images/ic_notification_home.png"),
  ic_user_home: require("./images/ic_user_home.png"),
  ic_input_cancel: require("./images/ic_input_cancel.png"),
  ic_email: require("./images/ic_email.png"),
  ic_lock: require("./images/ic_lock.png"),
  ic_eye_hidden: require("./images/ic_eye_hidden.png"),
  ic_view: require("./images/ic_view.png"),
  ic_hide: require("./images/ic_hide.png"),
  ic_check: require("./images/ic_check.png"),
  ic_check_white: require("./images/ic_check_white.png"),
  ic_free_rect: require("./images/ic_free_rect.png"),
  ic_save: require("./images/ic_save.png"),
  ic_edit: require("./images/ic_edit.png"),
  ic_info_close: require("./images/ic_info_close.png"),
  ic_read: require("./images/ic_read.png"),
  ic_easy_test: require("./images/ic_easy_test.png"),
  ic_hard_test: require("./images/ic_hard_test.png"),
  ic_premium: require("./images/ic_premium.png"),
  ic_home_custom: require("./images/ic_home_custom.png"),
  ic_home_flash: require("./images/ic_home_flash.png"),
  ic_home_quiz: require("./images/ic_home_quiz.png"),
  ic_home_practice: require("./images/ic_home_practice.png"),
  ic_menu: require("./images/ic_menu.png"),
  ic_plus: require("./images/ic_plus.png"),
  ic_down_arrow: require("./images/ic_down_arrow.png"),
  ic_delete: require("./images/ic_delete.png"),
  ic_search: require("./images/ic_search.png"),
  ic_timer: require("./images/ic_timer.png"),
  ic_previous: require("./images/ic_previous.png"),
  flash_bg: require("./images/flash_bg.png"),
  ic_up_arrow: require("./images/ic_up_arrow.png"),
  ic_score_circle: require("./images/ic_score_circle.png"),
  ic_score_container: require("./images/ic_score_container.png"),
  ic_user: require("./images/ic_user.png"),
  ic_flash_bookmark: require("./images/ic_flash_bookmark.png"),
  ic_flash_exam: require("./images/ic_flash_exam.png"),
  ic_flash_quick_set: require("./images/ic_flash_quick_set.png"),
  ic_flash_topic: require("./images/ic_flash_topic.png"),
  ic_cancel: require("./images/ic_cancel.png"),
  other_app: require("./images/other_app.png"),
  logo_prepare: require("./images/logo_prepare.png"),
  practice_bg: require("./images/practice_bg.png"),
  logo_white: require("./images/logo_white.png"),
  ic_reset: require("./images/ic_reset_data.png"),
  ic_review: require("./images/ic_review_app.png"),
  app_review_dialog: require("./images/app_review_dialog.jpg"),
  delete: require("./images/delete.png"),
  information: require("./images/information-button.png"),
  change: require("./images/change.png"),
  community: require("./images/group_users.png"),
  filter: require("./images/filter.png"),
  affiliate_image: require("./images/affiliate_image.jpg"),
  ic_font: require("./images/font.png"),
  ic_book_mark_unselected: require("./images/bookmark_unselected.png"),
  ic_book_mark_selected: require("./images/bookmark.png"),
  ic_network: require("./images/ic_network.png"),
  ic_checkbox: require("./images/Checkbox.png"),
  ic_crown: require("./images/Crown.svg"),
  firework: require('./images/firework.png'),

};

export const SVG_IMAGES = {
  crown: Crown,
  info: Info,
  check: Check,
  searchIcon: SearchIcon,
  filterIcon: FilterIcon,
  DownArrow: DownArrow,
  UpArrow: UpArrow,
  Bookmarks: Bookmarks,
  Book: Book,
  Clock: Clock,
  Lock: Lock,
  BookMarkSave: BookMarkSave,
  BackArrow: BackArrow,
  PracticeTestBG: PracticeTestBG,
  PracticeTestArt: PracticeTestArt,
  ic_practice_test: IcPracticeTest,
  IcRightIcon: IcRightIcon,
  Circle1: Circle1,
  Circle2: Circle2,
  Circle3: Circle3,
  ChangeIcon: ChangeIcon,
  homeIcon: HomeIcon,
  dashboardIcon: dashboardIcon,
};

